import {
  ChamberSearchParams,
  PagedChamberSearchParams,
} from 'models/chamberSearchParams';

export const convertSearchParamsToQueryString = (
  searchParams: ChamberSearchParams | PagedChamberSearchParams
) => {
  const { floodStatus, lastEventDate, accountId, ...params } = searchParams;

  const queryParams = new URLSearchParams({
    ...params,
  } as Record<string, string>);

  if (floodStatus) {
    floodStatus.forEach((value) =>
      queryParams.append('floodStatus', value.toString())
    );
  }

  if (lastEventDate) {
    queryParams.append('lastEventDate', lastEventDate.toISOString());
  }

  if (accountId) {
    queryParams.append('accountId', accountId.toString());
  }

  return queryParams.toString();
};
